import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import alertify from "alertifyjs";
import {ApiServiceService} from "../../../../../Services/api-service.service";
import {ToastService} from "../../../../../Services/ToastService";

@Component({
  selector: 'app-asin-generation',
  templateUrl: './asin-generation.component.html',
  styleUrls: ['./asin-generation.component.css']
})
export class AsinGenerationComponent implements OnInit{
  screenHeight = window.screen.height - 271; // 1058
  minHeight = 'min-height: ' + this.screenHeight + 'px !important'
  message2: string = '';
  type: string = '';

  screenHeight2 = window.screen.height - 630; // 428
  minHeight2 = 'min-height: ' + this.screenHeight2 + 'px !important'
  isLoading: boolean;


  constructor(private route: ActivatedRoute, private router: Router,
              private apiService: ApiServiceService, private spinner: ToastService) {
  }

  ngOnInit() {
      const snapshot2 = this.route.snapshot;
      this.type = snapshot2.queryParams['type']
    const snapshot = this.route.snapshot;
    this.message2 = snapshot.params["id"];
    this.stopCamera();
  }

  videoStream: MediaStream;
  stopCamera(): void {
    this.videoStream.getTracks().forEach(track => track.stop());
  }

  goHome() {
    this.router.navigate(['/']);
  }

  printIndividualAsinCard() {
    this.spinner.spin()
      let url ="";
      if (this.type == 'COMPANY'){
          url =`/auth/enumeration/print/asin/card/corporate/${this.message2}`
      }else {
          url = `/auth/enumeration/print/asin/card/individual/${this.message2}`;
      }
    alertify.set("notifier", "position", "top-center");
    alertify.success("Downloading ...");

    this.apiService.login(url,{}, { responseType: "blob" }).subscribe(
        (response: Blob) => {
          alertify.set("notifier", "position", "top-center");
          alertify.success("Download successful");

          const blob = new Blob([response], { type: "application/pdf" });

          // Create a Blob URL for the PDF content
          const blobUrl = window.URL.createObjectURL(blob);

          // Open PDF in a new tab
          // window.open(blobUrl, '_blank');

          const file = new Blob([response], { type: "application/pdf" });

          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);

          // Optionally, trigger a download by creating an anchor element
          const downloadLink = document.createElement("a");
          downloadLink.href = blobUrl;
          downloadLink.target = "_blank";
          downloadLink.download = this.message2 + "individual_asin_card.pdf"; // File name for download

          // Uncomment this line to trigger the download automatically
          downloadLink.click();
            this.spinner.hide();
        },
        (error) => {
            this.spinner.hide();
          this.isLoading = false;
          alertify.set("notifier", "position", "top-center");
          alertify.error("Error performing this operation");
        },
    );
  }
}
